import * as Bixby from '$/core';
import {
  CREATE_NEWS_INPROGRESS,
  CREATE_NEWS_SUCCESS,
  CREATE_NEWS_FAILURE,
  REMOVE_NEWS_INPROGRESS,
  REMOVE_NEWS_SUCCESS,
  REMOVE_NEWS_FAILURE,
  PUBLISH_NEWS_INPROGRESS,
  PUBLISH_NEWS_SUCCESS,
  PUBLISH_NEWS_FAILURE
} from './types';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '$/store';
import { NewsAdminService } from '$/services';
import { toastError, toastSuccess } from '$/store/toast/actions';

export const createNewsInProgressAction = () => {
  return { type: CREATE_NEWS_INPROGRESS };
};

export const createNewsSuccessAction = () => {
  setTimeout(() => window.location.reload(), 2000);
  return { type: CREATE_NEWS_SUCCESS };
};

export const createNewsFailureAction = (payload: Bixby.Models.BixbyError) => {
  return { type: CREATE_NEWS_FAILURE, payload };
};

export const removeNewsInProgressAction = () => {
  return { type: REMOVE_NEWS_INPROGRESS };
};

export const removeNewsSuccessAction = () => {
  return { type: REMOVE_NEWS_SUCCESS };
};

export const removeNewsFailureAction = (payload: Bixby.Models.BixbyError) => {
  return { type: REMOVE_NEWS_FAILURE, payload };
};

export const publishNewsInProgressAction = () => {
  return { type: PUBLISH_NEWS_INPROGRESS };
};

export const publishNewsSuccessAction = () => {
  return { type: PUBLISH_NEWS_SUCCESS };
};

export const publishNewsFailureAction = (payload: Bixby.Models.BixbyError) => {
  return { type: PUBLISH_NEWS_FAILURE, payload };
};

export const createNews = (
  request: Bixby.Models.CreateNewsRequest
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(createNewsInProgressAction());
    try {
      await NewsAdminService.createNews(request);
      dispatch(createNewsSuccessAction());
      await dispatch(toastSuccess('Company Update created'));
    } catch (error: any) {
      dispatch(createNewsFailureAction(error));
      await dispatch(toastError('Failed to create company update'));
    }
  };
};

export const removeNews =
  (news: Bixby.Models.AdminNews, retainTranscription: boolean): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
  dispatch(removeNewsInProgressAction());
  try {
    await NewsAdminService.removeNews(news, retainTranscription);
    dispatch(removeNewsSuccessAction());
    await dispatch(toastSuccess(`"${news.subject}" deleted`));
  } catch (error: any) {
    await dispatch(toastError(`Could not delete "${news.subject}"`));
    dispatch(removeNewsFailureAction(error));
  }
};

export const publishNews =
  (news: Bixby.Models.AdminNews): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
  dispatch(publishNewsInProgressAction());
  try {
    await NewsAdminService.publishNews(news);
    dispatch(publishNewsSuccessAction());
    await dispatch(toastSuccess(`"${news.subject}" published`));
  } catch (error: any) {
    await dispatch(toastError(`Could not publish "${news.subject}"`));
    dispatch(publishNewsFailureAction(error));
  }
};
